package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Pricing questions; also used for the FAQPage structured data. */
val PricingFaqs = listOf(
    RdText.PRICING_FAQ1_Q to RdText.PRICING_FAQ1_A,
    RdText.PRICING_FAQ2_Q to RdText.PRICING_FAQ2_A,
    RdText.PRICING_FAQ3_Q to RdText.PRICING_FAQ3_A,
    RdText.PRICING_FAQ4_Q to RdText.PRICING_FAQ4_A,
    RdText.PRICING_FAQ5_Q to RdText.PRICING_FAQ5_A,
)

@Composable
fun PricingFaqSection() {
    RdFaqBand(RdText.PRICING_FAQ_TITLE, PricingFaqs)
}
